<template>
<div>

  <v-form
  class="pa-6"
    ref="form"
    v-model="valid"
    lazy-validation>

    <h3 class="text-left mb-1 text-primary">Generate Certificate</h3>
    <p class="text-caption mb-4">Generá el certificado a partir del CSR.</p>
    <div class="d-flex ga-2 mb-6">
      <v-btn
          size="small"
          :disabled="!valid"
          color="primary"
          @click="validate">
        Generate Certificate >>
      </v-btn>
    </div>
    <v-row>
      <v-col md="6">
        <v-textarea
            v-model="localCSR"
            no-resize
            height="240"
            label="CSR"></v-textarea>
      </v-col>
      <v-col md="6">
        <v-textarea
            v-model="localPKCS7"
            no-resize
            height="240"
            label="pkcs7"></v-textarea>
      </v-col>
    </v-row>

  </v-form>
    <v-row class="px-6">
        <AdvancedSettings
        ref="advancedSettings"
        :canI="childState"
        v-on:increment="lockChild"
        :csr="localCSR"
        :key="localCSR"
        @setPKCS7="setPKCS7($event)"
      />
  </v-row>
</div>
</template>
<script>
import AdvancedSettings from './AdvancedSettings';

  export default  {
  components: {
    AdvancedSettings
  },
    props:["alisonSdk", "csr"],
    data: () => ({
      valid: true,
      name: '',
      localCSR: '',
      localPKCS7:'',
      childState: false,
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4',
      ],
      itemskeyOptions: [
          '1024','2048','4096'
      ],
      checkbox: false,
    }),
    mounted(){
      this.localCSR = this.csr
    },
    watch:{
      localCSR(value){
        console.log("cambio el local")
      },
      csr(value){
        console.log("watch csr:", value)
        this.localCSR = value;
      }
    },
    methods: {
      lockChild: function () {
        this.childState = false;
      },
      setPKCS7(value){
        this.localPKCS7 = value;
        this.$emit('enableTab', ['Install Certificate'])
        this.$emit('setPKCS7', value)
      },
      validate () {

        console.log("validate ref:", this.$refs)
        if (this.$refs.form.validate()) {
          console.log("es verdad", this.childState)
          this.snackbar = true;
          this.childState = true;
          this.$refs.advancedSettings.doIssue()
          console.log("childState", this.childState)
        }
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>
